import BranchCustomerProductList from 'components/pages/dashboard/branchCustomerProductType/BranchCustomerProductList';
import BranchCustomerProductMyRequests from 'components/pages/dashboard/branchCustomerProductType/BranchCustomerProductMyRequests';
import TcTab, { TabsProp } from 'components/UI/Tab/TcTab';
import { FC, useState } from 'react';

interface props {}
const BranchCustomerProductTab: FC<props> = () => {
  //states
  const [activeTab, setActiveTab] = useState<'myInventory' | 'myRequests'>('myInventory');

  const tabs: TabsProp[] = [
    {
      key: 'myInventory',
      title: 'موجودی انبار من',
      content: <BranchCustomerProductList />,
    },

    {
      key: 'myRequests',
      title: 'درخواست‌های من',
      content: <BranchCustomerProductMyRequests />,
    },
  ];

  return <TcTab activeTab={activeTab} onChange={setActiveTab} tabs={tabs} />;
};
export default BranchCustomerProductTab;
